import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles/fonts';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      position: 'relative',
      display: 'inline-block',
    },
    button: {
      padding: [2, 2],
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      backgroundColor: 'transparent',
      borderWidth: 0,
      fontSize: '24px',
      '&:hover': {
        cursor: 'pointer',
      },
      marginLeft: 'auto',
    },
    buttonText: {
      color: 'var(--x-breadcrumb-last)',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FontWeight.Medium,
    },
    icon: {
      marginLeft: 4,
      '& > svg': {
        verticalAlign: 'top',
        '& > path': {
          fill: colors.black,
        },
      },
    },
    container: {
      position: 'absolute',
      top: '100%',
      marginTop: 10,
      right: 0,
      padding: [12, 16],
      borderRadius: 10,
      boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
      background: 'var(--x-bg-1)',
    },
    items: {
      display: 'flex',
      gap: 4,
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    item: {
      fontSize: '24px',
      lineHeight: '24px',
      borderRadius: 4,
      padding: 4,
      '&:hover': {
        backgroundColor: 'var(--x-accent-1-6)',
        cursor: 'pointer',
      },
    },
    itemSelected: {
      backgroundColor: 'var(--x-accent-1-6)',
    },
    containerText: {
      display: 'block',
      textAlign: 'center',
      marginTop: 12,
      fontSize: '14px',
      lineHeight: '20px',
      color: 'var(--x-text-color-4)',
    },
  }),
  {
    name: 'skin-dropdown',
  },
);

export default useStyles;
